import React from "react";
import { Link } from "react-router-dom";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaEnvelope
} from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import SocialMediaIcon from "../../components/SocialMediaIcon";
import DonateButton from "../../components/DonateButton";
import {
  HeroSection,
  HeroInner,
  HeroHeading,
  HeroSubtitle,
  ConnectSection,
  ConnectInner,
  ConnectHeading,
  ConnectSubtitle,
  ConnectSubHeading,
  ConnectBodyText,
  EmailRow,
  SocialRow,
  SupportRow,
  AddressBlock,
  TeamCardsSection,
  TeamCardsGrid,
  TeamCard,
  TeamCardAccent,
  TeamCardBody,
  TeamCardHeading,
  TeamCardText,
  TeamCardButton
} from "./styled.components";
import {
  sitePurple,
  siteLightBlue,
  siteDarkGreen
} from "../../providers/Theme";
import {
  FACEBOOK_URL,
  INSTAGRAM_URL,
  LINKEDIN_URL,
  TWITTER_URL
} from "../../constants";

const teamCards = [
  {
    color: sitePurple,
    heading: "Board of Directors",
    body: "Meet the leaders providing governance, stewardship, and strategic direction for KRF.",
    label: "View Board",
    to: "/about-us/our-team/board-of-directors"
  },
  {
    color: siteLightBlue,
    heading: "Strategic Team",
    body: "Meet the advisors and community advocates supporting KRF's growth, outreach, and visibility.",
    label: "View Strategic Team",
    to: "/about-us/our-team/strategic-team"
  },
  {
    color: siteDarkGreen,
    heading: "Medical Advisory Council",
    body: "Meet the clinical and subject-matter experts supporting accurate, evidence-informed education.",
    label: "View Medical Council",
    to: "/about-us/our-team/medical-advisory-council"
  }
];

const OurTeam: React.FC = () => {
  return (
    <>
      <HeroSection>
        <HeroInner>
          <HeroHeading>Our Team</HeroHeading>
          <HeroSubtitle>
            Our work is guided by experienced leaders, medical experts, and
            dedicated public health professionals united around one mission:
            keeping every child safe from food allergy emergencies.
          </HeroSubtitle>
        </HeroInner>
      </HeroSection>

      <TeamCardsSection>
        <TeamCardsGrid>
          {teamCards.map(card => (
            <TeamCard key={card.heading} $color={card.color}>
              <TeamCardAccent $color={card.color} />
              <TeamCardBody>
                <TeamCardHeading $color={card.color}>
                  {card.heading}
                </TeamCardHeading>
                <TeamCardText>{card.body}</TeamCardText>
                <TeamCardButton
                  as={Link}
                  to={card.to}
                  $color={card.color}
                  onClick={() => window.scrollTo(0, 0)}
                >
                  {card.label}
                </TeamCardButton>
              </TeamCardBody>
            </TeamCard>
          ))}
        </TeamCardsGrid>
      </TeamCardsSection>

      <ConnectSection>
        <ConnectInner>
          <ConnectHeading>Connect With Us</ConnectHeading>
          <ConnectSubtitle>
            Stay connected with KRF for training updates, food allergy
            education, community partnerships, and opportunities to help more
            people prepare before an emergency happens.
          </ConnectSubtitle>

          <ConnectSubHeading>Get in Touch</ConnectSubHeading>
          <ConnectBodyText>
            Have a question, partnership idea, or media inquiry?
          </ConnectBodyText>
          <EmailRow href="mailto:outreach@kyahraynefoundation.org">
            <SocialMediaIcon
              FaIcon={FaEnvelope}
              link="mailto:outreach@kyahraynefoundation.org"
            />
            outreach@kyahraynefoundation.org
          </EmailRow>

          <ConnectSubHeading>Follow Along</ConnectSubHeading>
          <ConnectBodyText>
            Follow KRF for education, updates, community stories, and new
            resources.
          </ConnectBodyText>
          <SocialRow>
            <SocialMediaIcon FaIcon={FaFacebookF} link={FACEBOOK_URL} />
            <SocialMediaIcon FaIcon={FaInstagram} link={INSTAGRAM_URL} />
            <SocialMediaIcon FaIcon={FaLinkedinIn} link={LINKEDIN_URL} />
            <SocialMediaIcon FaIcon={FaXTwitter} link={TWITTER_URL} />
          </SocialRow>

          <ConnectSubHeading>Support the Work</ConnectSubHeading>
          <SupportRow>
            <AddressBlock>
              <strong>Donations can be mailed to:</strong>
              <br />
              Kyah Rayne Foundation
              <br />
              3104 E. Camelback Rd., Ste. 1172
              <br />
              Phoenix, Arizona 85016
            </AddressBlock>
            <DonateButton />
          </SupportRow>
        </ConnectInner>
      </ConnectSection>
    </>
  );
};

export default OurTeam;
